import React from 'react'
import Experience from './Experience.jsx'

import EXPERIENCE_SINCRONIA_IMAGE_PATH from 'images/experience_sincronia.jpg'
import EXPERIENCE_SINCRONIA_SONG_PATH from 'audio/5. DESCALZA MB.mp3'

const SincroniaText = () => (
	<span className="text-center">
		<p>Si te descalzas y pones tus pies en la tierra o los metes en el mar: ¿Qué encontras?</p>
		<p>Bailar con el ritmo de la tierra.</p>
		<p>Entregarte a sus procesos.</p>
		<p>Morir, renacer, florecer y envejecer.</p>
		<p>Y en los ciclos, la introspección.</p>
		<p>Cargada de dolor.</p>
		<p className="mb-3">No más que el soportable.</p>

		<p className="mb-3">Ya despertaste a tu interior, escuchaste tu rugido y aceptaste tu dolor.</p>


		<p>El ciclo vuelve a comenzar.</p>
		<p>Y cuando sientas cansancio de tanto excavar, es momento de entregarte al otoño.</p>
		<p>De ver morir con él lo que ya no.</p>
		<p>Al final siempre llega la primavera.</p>
		<p>Y no te olvides de anidar el verano.</p>
		<p>También es menester el disfrute.</p>
		<p>No existe una estación sin su predecesora.</p>
		<p>Dejate llevar con las mareas de los ciclos.</p>
		<p>No les temas.</p>
		<p>Nos mantiene vivas.</p>
	</span>
)

const ExperienceSincronia = props => {
	return (<Experience
		image={EXPERIENCE_SINCRONIA_IMAGE_PATH}
		title={"Sincronia"}
		phrase={"¿Te animás a caminar tus propios ciclos sin querer saltarte ninguna estación, confiando en que incluso lo que muere en vos también sabe florecer?"}
		phrase_rect={{ top: 89, left: 50, width: 70, height: 20 }}
		text={<SincroniaText />}
		text_rect={{ top: 44, left: 76.5, width: 40, height: 65 }}
		text_interaction_zone_rect={{ top: 0, left: 23, width: 7, height: 10 }}
		song={EXPERIENCE_SINCRONIA_SONG_PATH}
		song_rect={{ top: 27, left: 50, width: 7, height: 10 }}
		{...props}
	/>)			
}

export default ExperienceSincronia